
import { Component, Vue, Watch } from "vue-property-decorator";
import { IDefaultShippingOrderModel, ITypeModel } from "@/api/types";

import Pagination from "@/components/Pagination/index.vue";

import {
  getNumberTypes,
  getRecordsStatus,
  getSuppliersList,
} from "@/api/inquiry";
import {
  getDetailHeader,
  getPurchaseOrderDetail,
  getPurchaseOrderList,
} from "@/api/proforma";

import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { cal } from "@/utils/cal";

@Component({
  name: "quotationDetails",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  private isShowMore = false;
  private isShowMore2 = false;
  private isShowMore3 = false;
  private showMatching = false;
  private showFile = false;
  private showList = false;
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  private conversionExchangeRate = 0;

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  private listParam = {
    approvalRecordId: null,
    inquirySheetId: null,
    refNumber: null,
    refTypeId: null,
    quotedStatus: null,
    orderStatus: null,
    supplier: null,
    hqProductName: null,
    productName: null,
    type: null,
  };
  public searchForm = [
    {
      label: "号码查询",
      prop: "numberKeyword",
      key: "numberKeyword",
      type: "input",
      placeholder: "请输入号码的关键字",
      value: "",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入华强品名",
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      type: "sn-popver",
      show: true,
      fixed: true,
      disabled: false,
      icon6: require("@/assets/images/ic_customer_sample.png"),
      icon_key6: "sample",
      icon_value6: true,
      icon_key6_1: "sampleType",
      icon_value6_1: "CUSTOMER",
      content6: "工厂付款，客人不收费",
      icon7: require("@/assets/images/ic_supplier_sample.png"),
      icon_key7: "sample",
      icon_value7: true,
      icon_key7_1: "sampleType",
      icon_value7_1: "SUPPLIER",
      content7: "工厂不付款，客人收费",
      icon8: require("@/assets/images/ic_sample.png"),
      icon_key8: "sample",
      icon_value8: true,
      icon_key8_1: "sampleType",
      icon_value8_1: "ALL",
      content8: "不收付样品"
    },
    {
      label: "HQ交易号码",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      show: true,
      disabled: false,
    },
    {
      label: "参照号",
      prop: "inquiryRefNumber",
      key: "inquiryRefNumber",
      show: true,
      disabled: false,
    },
    {
      label: "参照号类型",
      prop: "inquiryRefType",
      key: "inquiryRefType",
      show: true,
      disabled: false,
    },
    {
      label: "供应商号码",
      prop: "supplierProductNumber",
      key: "supplierProductNumber",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "产品描述1",
      prop: "productAttribute1",
      key: "productAttribute1",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品描述2",
      prop: "productAttribute2",
      key: "productAttribute2",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品描述3",
      prop: "productAttribute3",
      key: "productAttribute3",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品描述4",
      prop: "productAttribute4",
      key: "productAttribute4",
      show: true,
      disabled: false,
      show_key: "show1"
    },
    {
      label: "工艺",
      prop: "technicDesc",
      key: "technicDesc",
      show: true,
      disabled: false,
      show_key: "show1"
    },
    // {
    //   label: "technic",
    //   prop: "technic",
    //   key: "technic",
    //   show: true,
    //   disabled: false,
    //   show_key: "show1"
    // },
    {
      label: "产品信息",
      prop: "productInfoDesc",
      key: "productInfoDesc",
      show: true,
      disabled: false,
      show_key: "show1"
    },
    // {
    //   label: "Product Info",
    //   prop: "productInfo",
    //   key: "productInfo",
    //   show: true,
    //   disabled: false,
    //   show_key: "show1"
    // },
    {
      label: "车型/Car Application",
      prop: "carApplication",
      key: "carApplication",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "下单数量",
      prop: "orderQuantity",
      key: "orderQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "数量变动",
      prop: "quantityChange",
      key: "quantityChange",
      show: true,
      disabled: false,
    },
    {
      label: "产品单位",
      prop: "productUnit",
      key: "productUnit",
      show: true,
      disabled: false,
    },
    {
      label: "订单交货进度",
      prop: "deliveryProgress",
      key: "deliveryProgress",
      show: true,
      disabled: false,
    },
    {
      label: "折后采购单价",
      prop: "purchaseDiscountUnitPrice",
      key: "purchaseDiscountUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "采购单价",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "采购总价",
      prop: "purchaseTotalPrice",
      key: "purchaseTotalPrice",
      show: true,
      disabled: false,
    },
    {
      label: "PO号码",
      prop: "poNumber",
      key: "poNumber",
      show: true,
      disabled: false,
    },
    {
      label: "壳体包装要求",
      prop: "packagingRequirements",
      key: "packagingRequirements",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "出货备注",
      prop: "shippingRemark",
      key: "shippingRemark",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
  ] as any;
  public customerInfo = {} as any;
  public id = "";
  public customerStatus = "";
  public customerInfoFields = [
    {
      label: "采购订单号",
      key: "poCode",
    },
    {
      label: "交易公司",
      key: "company",
    },
    {
      label: "采购订单生成时间",
      key: "createTime",
    },
    {
      label: "当前状态",
      key: "status",
    },
    {
      label: "供应商编号",
      key: "supplierCode",
    },
    {
      label: "供应商简称",
      key: "supplierAbbreviation",
    },
    {
      label: "供应商全称",
      key: "supplierName",
    },
    {
      label: "标记名称",
      key: "markName",
    },
    {
      label: "下单销售员",
      key: "seller",
    },
    {
      label: "采购员",
      key: "purchase",
    },
    {
      label: "打标员",
      key: "marker",
    },
    {
      label: "应付会计",
      key: "accountPeriod",
    },
    {
      label: "产品经理",
      key: "productManager",
    },
    {
      label: "交货进度",
      key: "deliveryProgress",
    },
    {
      label: "交期",
      key: "contractualDeliveryDate",
    },
    {
      label: "约定账期",
      key: "agreedAccountPeriod",
    },
    {
      label: "产品品名",
      key: "productName",
    },
    {
      label: "产品总数量",
      key: "productQuantity",
    },
    {
      label: "供应商总货款",
      key: "supplierTotalPayment",
    },
    {
      label: "最后修改时间",
      key: "updatedTime",
    },
    {
      label: "唛头",
      key: "markLetters",
    }
  ] as any;
  // public customerInfoFields2 = [
  //   {
  //     label: "产品品名",
  //     key: "productName",
  //   },
  //   {
  //     label: "产品总数量",
  //     key: "productQuantity",
  //   },
  //   {
  //     label: "供应商总货款",
  //     key: "supplierTotalPayment",
  //   },
  //   {
  //     label: "最后修改时间",
  //     key: "updatedTime",
  //   },
  // ] as any;

  created() {
    this.id = this.$route.query.id as string;
    this.getHeaderInfo(this.$route.query.id as string);
    // this.customerInfo =  this.$route.params.item && JSON.parse(this.$route.params.item as string);
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getDetailHeader();
    this.getList();
  }

  private async getHeaderInfo(id) {
    const params = {
      pageNumber: 1,
      pageSize: 1,
    };
    this.listLoading = false;
    const { list }: any = await getPurchaseOrderList(id, params);
    if (list.length > 0) {
      this.customerInfo = list[0];
    }
  }

  private async getDetailHeader() {
    const res: any = await getDetailHeader(this.id);
    this.customerInfo = res;
  }

  private handleSuccess() {
    this.showMatching = false;
    this.getList();
  }

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.listParam = data && data !== "reset" ? data : {};
    this.getList();
  }

  private handleFilter() {
    this.table.pageNumber = 1;
    this.getList();
  }

  public handleCommand(command) {
    this[command]();
  }

  // 文件管理
  public async handleFile() {
    this.showFile = true;
  }

  // 交货进度
  public async handleDelivery() {
    this.showList = true;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getPurchaseOrderDetail(this.id, params);
    this.table.total = +total;
    this.table.list = list;
    // this.table.list.forEach((item) => {
    //   this.handleCalculate(item);
    // });
    let newArr = [];
    if (list.length > 0) {
      list[0].models.forEach((e, index) => {
        let newObj = {
          label: e.typeName,
          prop: "num" + index,
          key: "num" + index,
          show: true,
          disabled: false,
          show_key: "show3",
        };
        // newArr.push(newObj)
        if (this.tableCol.findIndex((elm) => elm.key === newObj.key) === -1) {
          this.tableCol = this.changeArr(this.tableCol, 2, newObj);
        }
      });
    }
    // this.tableCol = [...this.tableCol,...newArr]
    if (list.length > 0) {
      list.map((item) => {
        if (item.models.length > 0) {
          item.models.forEach((res, num) => {
            item[`num${num}`] = res.number;
          });
        }
      });
    }
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }
  private changeArr(arrayList, index, value) {
    arrayList.splice(index, 0, value);
    return arrayList;
  }

  // 自动计算
  private async handleCalculate(item) {
    const purchaseDiscount = +item.purchaseDiscount;
    const purchaseDiscountUnitPrice = +cal.cheng(
      +cal.jian(1, purchaseDiscount),
      +item.purchaseUnitPrice
    );
    this.$set(
      item,
      "purchaseDiscountUnitPrice",
      purchaseDiscountUnitPrice || 0
    );
    // 获取采购总价
    const purchaseTotalPrice = +cal.cheng(
      purchaseDiscountUnitPrice,
      item.orderQuantity || 0
    );
    this.$set(item, "purchaseTotalPrice", purchaseTotalPrice);
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }

  private showMore3() {
    this.isShowMore3 = !this.isShowMore3;
  }

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }
}
